import React from 'react';

const ConfigurationHeader = ({ 
  user,
  loading,
  onOpenTemplateModal,
  onInitializeDefaultData,
  onOpenAddModal
}) => {
  return (
    <div className="card-header bg-white d-flex justify-content-between align-items-center">
      <h5 className="card-title mb-0">
        <i className="bi bi-file-earmark-text me-2"></i>
        {user?.role === 'admin' ? 'Plantillas Públicas del Sistema' : 'Mis Tipos de Documentos'}
      </h5>
      <div className="d-flex gap-2">
        {user?.role !== 'admin' && (
          <button 
            className="btn btn-outline-secondary btn-sm"
            onClick={onOpenTemplateModal}
            disabled={loading}
          >
            <i className="bi bi-download me-2"></i>
            Importar Plantilla
          </button>
        )}
        <button 
          className="btn btn-outline-primary btn-sm"
          onClick={onInitializeDefaultData}
          disabled={loading}
          style={{display: user?.role === 'admin' ? 'inline-block' : 'none'}}
        >
          <i className="bi bi-database me-2"></i>
          Inicializar Sistema
        </button>
        <button 
          className="btn btn-primary"
          onClick={onOpenAddModal}
        >
          <i className="bi bi-plus-circle me-2"></i>
          {user?.role === 'admin' ? 'Agregar Plantilla' : 'Agregar Tipo'}
        </button>
      </div>
    </div>
  );
};

export default ConfigurationHeader;
